<template>
  <footer class="footer has-cards">

    <div class="container">
      <div class="row row-grid align-items-center my-md">
        <div class="col-lg-12">
          <h3 class="text-primary font-weight-light mb-2">dzenburo.ru</h3>
          <h4 class="mb-0 font-weight-light">Профессиональная разработка проектов высокой сложности</h4>
        </div>

      </div>
      <hr>
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-4">
          <div class="copyright">
            &copy; {{ year }}
            dzenburo.ru
          </div>
        </div>
        <div class="col-md-8">
          <p>Powered by IrenSystem</p>


        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
